import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './AddProductPage.css'; // Reuse the same CSS

const EditProductPage = () => {
    const [name, setName] = useState('');
    const [quantity, setQuantity] = useState('');
    const { id } = useParams(); // Get product ID from URL
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProduct = async () => {
            const productDoc = doc(db, "products", id);
            const docSnap = await getDoc(productDoc);

            if (docSnap.exists()) {
                const productData = docSnap.data();
                setName(productData.name);
                setQuantity(productData.quantity);
            } else {
                console.log("No such document!");
            }
        };
        fetchProduct();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const productDoc = doc(db, "products", id);
        await updateDoc(productDoc, {
            name: name,
           
        });
        navigate('/products');
    };

    return (
        <div className="form-container">
            <h1>Edit Product</h1>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Product Name</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label>Quantity</label>
                    <input
                        type="number"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="submit-button">Update Product</button>
            </form>
        </div>
    );
};

export default EditProductPage;